"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = BalanceItem;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@sart/styles");
var _icons = require("@sart/icons");
var _client = _interopRequireDefault(require("@sart/client"));
var _content = require("@sart/content");
var _utilities = require("@sart/utilities");
var _Text = _interopRequireDefault(require("./Text"));
var _Space = _interopRequireDefault(require("./Space"));
var _moment = _interopRequireDefault(require("moment"));
var _excluded = ["balance", "style", "placeholderStyle", "bodyStyle", "headerStyle", "titleStyle", "descriptionStyle", "iconColor"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function typeOfBalance(_ref) {
  var units = _ref.units;
  if (units === "DATAMB" || units === "DATAKB" || units === "DATAGB" || units === "GB" || units === "MB" || units === "KB" || units === "Kb" || units === "Mb" || units === "Gb") {
    return 'data';
  }
  if (units === "MINS") {
    return 'minutes';
  }
  if (units === "TEXTS" || units === "TEXT") {
    return 'sms';
  }
  return 'hybrid';
}
function getTranslation(balance) {
  var toReturn = balance.balanceDefinition.displayName;
  if (balance.balanceDefinition && balance.balanceDefinition.displayDetails) {
    balance.balanceDefinition.displayDetails.map(function (detail) {
      if (detail.language === _client["default"].cache.language) {
        toReturn = detail.displayName;
      }
    });
  }
  return toReturn;
}
var formatDate = function formatDate(date, language) {
  if (date) {
    var formatted = (0, _moment["default"])(date).utc().locale(language).format('ddd D MMM');
    var elements = formatted.split('.').join('').split(' ');
    elements[0] = elements[0][0].toUpperCase() + elements[0].slice(1);
    elements[2] = elements[2][0].toUpperCase() + elements[2].slice(1);
    return elements.join(' ');
  }
  return null;
};
function balanceConverter(balance) {
  if (balance) {
    if (balance.units === "bytes") {
      balance.units = "DATAMB";
    }
    if (balance.units === "Kb" || balance.units === "KB" || balance.units === "DATAKB") {
      balance.units = "DATAMB";
    }
    if (balance.units === "Mb" || balance.units === "MB" || balance.units === "DATAMB") {
      balance.units = "DATAMB";
    }
    if (balance.units === "Gb" || balance.units === "GB" || balance.units === "DATAGB") {
      balance.units = "DATAMB";
    }
    return balance;
  }
}
function BalanceItem(props) {
  var content = (0, _content.useContent)();
  var balance = props.balance,
    style = props.style,
    placeholderStyle = props.placeholderStyle,
    bodyStyle = props.bodyStyle,
    headerStyle = props.headerStyle,
    titleStyle = props.titleStyle,
    descriptionStyle = props.descriptionStyle,
    iconColor = props.iconColor,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var type = typeOfBalance(balance);
  var name = getTranslation(balance);
  function getAmountsToDisplay(balance) {
    balance = balanceConverter(balance);
    if (balance.startingQuantity === -1) {
      return content.balance.unlimited;
    }
    if (balance.units === "DATAMB") {
      return (balance.quantity / 1024).toFixed(1) + " / " + (balance.startingQuantity / 1024).toFixed(1) + " MB";
    } else if (balance.units === "MINS") {
      return parseInt(balance.quantity) + " / " + parseInt(balance.startingQuantity);
    } else {
      return balance.quantity + " / " + balance.startingQuantity;
    }
  }
  var language;
  if (_client["default"].cache.language === 'en') {
    language = 'en-gb';
  } else if (_client["default"].cache.language === 'es') {
    language = 'es-us';
  }
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.container, style]
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.placeholder, placeholderStyle]
  }, /*#__PURE__*/_react["default"].createElement(_icons.ProductIconType, {
    color: iconColor,
    type: type
  })), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.body, bodyStyle]
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.header, headerStyle]
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [styles.title, titleStyle]
  }, name), /*#__PURE__*/_react["default"].createElement(_Text["default"], (0, _extends2["default"])({
    style: [styles.description, descriptionStyle]
  }, (0, _utilities.testID)('BalanceAmount' + name)), getAmountsToDisplay(balance))), balance.expiryDateTime && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [styles.expiry, descriptionStyle]
  }, content.dashboard.exp, " ", formatDate(balance.expiryDateTime, language))));
}
BalanceItem.propTypes = {
  balance: _propTypes["default"].object
};
var styles = _reactNative.StyleSheet.create({
  container: {
    height: 72,
    flexDirection: 'row',
    borderRadius: 8,
    backgroundColor: _styles.backgroundColors.darkCharcoal,
    elevation: 8
    // ...shadows.shadowByElevation(8),
  },
  placeholder: {
    // flex: 1,
    width: 72,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: _styles.backgroundColors.subtle,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8
  },
  body: {
    flexDirection: 'column',
    flex: 1,
    padding: 12,
    alignSelf: 'center'
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: _objectSpread({
    fontSize: 14,
    lineHeight: 36,
    fontWeight: 'bold',
    color: _styles.colors.white
  }, _styles.typography.lightbold),
  description: _objectSpread({
    fontSize: 14,
    // lineHeight: 48,
    color: _styles.colors.white
  }, _styles.typography.demi),
  expiry: _objectSpread(_objectSpread({}, _styles.typography.demi), {}, {
    fontSize: 14,
    // lineHeight: 48,
    color: _styles.colors.white
  }, _styles.typography.demi)
});